(function () {
    const PersonalizeProduct = {
        selectors: {
            wrapper: "[data-section-type='personalize-popup']",
            extraCharmsWrapper: "[data-section-type='add-charm-popup']",
            overlay: ".js-popup-overlay-personalize",
            container: ".personalize__popup-container",
            popupTrigger: ".customized_button",
            personalizeTop: ".personalize_top",
            personalizeBelt: ".personalize_belt",
            personalizeBottom: ".personalize_bottom",
            popupClose: ".js-popup-close-personalize",
            badgeCollectionBtns: ".badge-collection",
            extraCharmCollectionBtns: ".extra-charm-collection",
            badgeItemWrappers: ".badge-collection-item-list",
            badgeCollectionItems: ".badge-collection__item",
            extraCharmsCollectionItems: ".extra-badge-collection__item",
            badgeCollectionError: ".badge-collection-error",
            badgeItem: ".personalize_badge",
            badgeAction: ".badge-action",
            badgeActionDelete: ".badge-action[data-name='delete']",
            badgeActionDrag: ".badge-action[data-name='drag']",
            badgeInput: ".personalize-badge__input",

            badgeCurrentCount: "#charms-current-qty",
            badgeMaxCount: "#charms-max-qty",

            swatches: ".personalization-swatch",

            addToCart: ".main-personalize__addToCart",

            extraCharmsInput: "input[name='add-extra-charms']",
            extraCharmPopup: ".add_extra_charm__popup-container",
            extraCharmPopupClose: ".personalize__charm-popup-close",
            selectedExtraCharms: ".badge-collection-item-list-selected",
            extraCharmRemoveBtns: ".extra-charm-remove",
            extraCharmsAddToCartBtn: ".add_to_cart-extra--charms"
        },

        classes: {
            is_visible: "is-visible",
        },

        currentState: {
            charmsPopupOpen: false,
            popupOpen: false,
            currentBadgeCount: 0,
            maxBadgeCount: 6,
            additionalCharms: [],
            extraCharms: {
                count: 0,
                charms: []
            }
        },

        init: function () {
            this.wrapper = document.querySelector(this.selectors.wrapper);
            this.container = this.wrapper.querySelector(this.selectors.container);
            this.popupTrigger = Array.from(document.querySelectorAll(`${this.selectors.popupTrigger}, ${this.selectors.popupClose}`));
            this.overlay = this.wrapper.querySelector(this.selectors.overlay);
            this.badgeCollectionBtns = Array.from(this.wrapper.querySelectorAll(this.selectors.badgeCollectionBtns));
            this.badgeItemWrappers = Array.from(this.wrapper.querySelectorAll(this.selectors.badgeItemWrappers));
            this.badgeCollectionItems = Array.from(this.wrapper.querySelectorAll(this.selectors.badgeCollectionItems));
            this.personalizeBelt = this.wrapper.querySelector(this.selectors.personalizeBelt);
            this.badgeCurrentCount = this.wrapper.querySelector(this.selectors.badgeCurrentCount);
            this.badgeMaxCount = this.wrapper.querySelector(this.selectors.badgeMaxCount);
            this.swatches = Array.from(this.wrapper.querySelectorAll(this.selectors.swatches));
            this.addToCart = this.wrapper.querySelector(this.selectors.addToCart);
            this.badgeError = this.wrapper.querySelector(this.selectors.badgeCollectionError);

            if (window.personalization && window.personalization.additional_charm_product) {
                // Additonal Charms
                this.extraCharmsWrapper = document.querySelector(this.selectors.extraCharmsWrapper);
                this.extraCharmCollectionBtns = Array.from(this.extraCharmsWrapper.querySelectorAll(this.selectors.extraCharmCollectionBtns));
                this.extraCharmsItemWrappers = Array.from(this.extraCharmsWrapper.querySelectorAll(this.selectors.badgeItemWrappers));
                this.extraCharmsCollectionItems = Array.from(this.extraCharmsWrapper.querySelectorAll(this.selectors.extraCharmsCollectionItems));
                this.extraCharmsInputs = Array.from(document.querySelectorAll(this.selectors.extraCharmsInput));
                this.extraCharmPopup = document.querySelector(this.selectors.extraCharmPopup);
                this.extraCharmPopupOverlay = this.extraCharmPopup.previousElementSibling;
                this.extraCharmPopupClose = document.querySelector(this.selectors.extraCharmPopupClose);
                this.selectedExtraCharms = this.extraCharmsWrapper.querySelector(this.selectors.selectedExtraCharms);
                this.extraCharmsAddToCartBtn = this.extraCharmsWrapper.querySelector(this.selectors.extraCharmsAddToCartBtn);
                this.addAdditionalCharmsOptionLabel = document.querySelector(".extra-charms-option-selected");
                this.charmBadgeError = this.extraCharmsWrapper.querySelector(this.selectors.badgeCollectionError);
            }
            this.id = [];
            this.bindEvents();
            this.handleVariantChange();
        },

        bindEvents: function () {
            var _ = this;
            this.popupTrigger.forEach((trigger) => trigger.addEventListener("click", _.tooglePopup.bind(this), true));
            this.badgeCollectionBtns.forEach((badgeCollectionBtn) => badgeCollectionBtn.addEventListener("click", _.handleCollectionChange.bind(this), true));
            this.badgeCollectionItems.forEach((badgeCollectionItem) => badgeCollectionItem.addEventListener("click", _.handleBadgeItemClick.bind(this), true));
            this.swatches.forEach((swatch) => swatch.addEventListener("click", _.handleColorChange.bind(this), true));
            this.addToCart.addEventListener("click", _.handleAddToCart.bind(this), true);
            if (window.personalization && window.personalization.additional_charm_product) {
                this.extraCharmsCollectionItems.forEach((extraCharmsCollectionItem) => extraCharmsCollectionItem.addEventListener("click", _.handleExtraCharmItemClick.bind(this), true));
                this.extraCharmCollectionBtns.forEach((extraCharmCollectionBtn) => extraCharmCollectionBtn.addEventListener("click", _.handleExtraCharmCollectionChange.bind(this), true));
                this.extraCharmsInputs.forEach((extraCharmsInput) => extraCharmsInput.addEventListener("click", _.toggleExtraCharmsPopup.bind(this), true));
                this.extraCharmsInputs.forEach((extraCharmsInput) => extraCharmsInput.addEventListener("change", _.toggleExtraCharmsPopup.bind(this), true));
                this.extraCharmPopupClose.addEventListener("click", _.closeExtraCharmPopup.bind(this), true);
                this.extraCharmsAddToCartBtn.addEventListener("click", _.handleExtraCharmAddToCart.bind(this), true);
            }
            window.addEventListener("variantChange:personalize", _.handleVariantChange.bind(this), true);
        },

        tooglePopup: function () {
            const _ = this;
            if (this.currentState.popupOpen) {
                // Close Popup
                this.overlay.classList.remove(this.classes.is_visible);
                this.container.style.display = "none";
                this.currentState.popupOpen = false;
                document.body.classList.remove("popup-personalize-open");
            } else {
                // Check which collection is available
                _.forEachWithBreak(this.badgeCollectionBtns, (badgeCollectionBtn) => {
                    let availableCollections = badgeCollectionBtn.dataset.available;
                    if (!availableCollections) {
                        badgeCollectionBtn.click();
                        return false;
                    }
                    const listOfAvailableCollections = availableCollections.split(",").map((item) => item.toLowerCase());
                    let collarSize = (_.variant.option1).toLowerCase();
                    if (listOfAvailableCollections.indexOf(availableCollections) > -1) {
                        badgeCollectionBtn.click();
                        return false;
                    }
                    return true;
                });

                // Open Popup
                this.overlay.classList.add(this.classes.is_visible);
                this.container.style.display = "block";
                this.currentState.popupOpen = true;
                document.body.classList.add("popup-personalize-open");
            }
        },

        toggleExtraCharmsPopup: function (event) {
            // console.log("Extra charms");
            const selectedValue = event.currentTarget.value;
            if (selectedValue === 'with-additional-charms') {
                document.body.classList.add("popup-personalize-open");
                this.extraCharmPopup.style.display = "block";
                this.extraCharmPopupOverlay.classList.add("is-visible");
                this.addAdditionalCharmsOptionLabel.innerText = 'With Additional Charms';
            } else {
                document.body.classList.remove("popup-personalize-open");
                this.extraCharmPopup.style.display = "none";
                this.extraCharmPopupOverlay.classList.remove("is-visible");
                this.currentState.extraCharms = { count: 0, charms: [] };
                this.addAdditionalCharmsOptionLabel.innerText = 'No Additional Charms';
                this.renderSelectedExtraCharms();
            }
        },

        closeExtraCharmPopup: function () {
            if (this.currentState.extraCharms.count === 0) {
                document.querySelector("input[name='add-extra-charms'][value='no-additional-charms']").click();
                this.currentState.extraCharms = { count: 0, charms: [] };
                this.addAdditionalCharmsOptionLabel.innerText = 'No Additional Charms';
                this.renderSelectedExtraCharms();
            }
            document.body.classList.remove("popup-personalize-open");
            this.extraCharmPopup.style.display = "none";
            this.extraCharmPopupOverlay.classList.remove("is-visible");
        },

        handleCollectionChange: function (event) {
            const _ = this;
            let collarSize = (this.variant.option1).toLowerCase();
            const isCurrentCollectionAvailable = event.currentTarget.dataset.available;
            if (isCurrentCollectionAvailable) {
                const listOfAvailableCollections = isCurrentCollectionAvailable.split(",").map((item) => item.toLowerCase());
                if (listOfAvailableCollections.indexOf(collarSize) > -1) {
                    this.badgeError.classList.add("active");
                    setTimeout(function () {
                        _.badgeError.classList.remove("active");
                    }, 2500);
                    return;
                }
            }

            this.badgeCollectionBtns.forEach((badgeCollectionBtn) => badgeCollectionBtn.closest("li").classList.remove("active"));
            event.currentTarget.closest("li").classList.add("active");
            const collectionHandle = event.currentTarget.dataset.collection;
            this.badgeItemWrappers.forEach((badgeItemWrapper) => {
                if (badgeItemWrapper.dataset.collectionId === collectionHandle) {
                    badgeItemWrapper.classList.add('active');
                    if (document.querySelector('.current-badge-collection-name')) {
                        document.querySelector('.current-badge-collection-name').innerText = event.currentTarget.closest(".badge-collection").dataset.title;
                    }
                } else {
                    badgeItemWrapper.classList.remove('active')
                }
            });
        },

        handleExtraCharmCollectionChange: function (event) {
            console.log('Exta charm collection change!')
            // const _ = this;
            // let collarSize = (this.variant.option3).toLowerCase();
            // const isCurrentCollectionAvailable = event.currentTarget.dataset.available;
            // if (isCurrentCollectionAvailable) {
            //     const listOfAvailableCollections = isCurrentCollectionAvailable.split(",").map((item) => item.toLowerCase());
            //     if (listOfAvailableCollections.indexOf(collarSize) > -1) {
            //         this.charmBadgeError.classList.add("active");
            //         setTimeout(function () {
            //             _.charmBadgeError.classList.remove("active");
            //         }, 2500);
            //         return;
            //     }
            // }

            this.extraCharmCollectionBtns.forEach((extraCharmCollectionBtn) => extraCharmCollectionBtn.closest("li").classList.remove("active"));
            event.currentTarget.closest("li").classList.add("active");
            const collectionHandle = event.currentTarget.dataset.collection;
            this.extraCharmsItemWrappers.forEach((extraCharmsItemWrapper) => {
                if (extraCharmsItemWrapper.dataset.collectionId === collectionHandle) {
                    extraCharmsItemWrapper.classList.add('active');
                    if (this.extraCharmsWrapper.querySelector('.current-extra-charm-collection-name')) {
                        this.extraCharmsWrapper.querySelector('.current-extra-charm-collection-name').innerText = event.currentTarget.closest(".extra-charm-collection").dataset.title;
                    }
                } else {
                    extraCharmsItemWrapper.classList.remove('active')
                }
            });
        },

        handleBadgeItemClick: function (event) {
            console.log(event);
            if (this.currentState.currentBadgeCount >= this.currentState.maxBadgeCount) return;
            const badgeImage = event.currentTarget.dataset.src;
            let badgeValue = event.currentTarget.dataset.alt;
            const badgeVariantId = event.currentTarget.dataset.variantId; 
            if (!badgeValue) {
                let temp_badgeValue = badgeImage.split("/");
                badgeValue = temp_badgeValue[temp_badgeValue.length - 1].split(".")[0];
            }

            const badgeCollectionTitle = event.currentTarget.dataset.title;
            let badgeItemHtml = this.getBadgeHTML();
            let stringsToReplaceWith = { "BadgeVariantId": badgeVariantId, "BadgeImage": badgeImage, "BadgeCollectionTitle": badgeCollectionTitle, "BadgeValue": badgeValue, "Index": this.getUniqueId() };
            badgeItemHtml = badgeItemHtml.replace(/\b(?:BadgeVariantId|BadgeImage|BadgeCollectionTitle|BadgeValue|Index)\b/gi, matched => stringsToReplaceWith[matched]);
            this.personalizeBelt.insertAdjacentHTML("beforeend", badgeItemHtml);
            this.bindBadgeEvents();
            this.manageBadgeCount("plus");
        },

        handleExtraCharmItemClick: function (event) {
            const item = event.currentTarget;
            const itemParent = item.closest("li");
            itemParent.classList.toggle("active");
            if (itemParent.classList.contains("active")) {
                const { extraCharms: { count, charms } } = this.currentState;
                const uniqueId = this.getUniqueId();
                const charmProps = { uniqueId: uniqueId, title: item.dataset.alt, image: item.dataset.src };
                this.currentState.extraCharms.count = count + 1;
                charms.push(charmProps);
                this.renderSelectedExtraCharms();
                return;
            }

            this.handleRemoveExtraCharmItem(event);
        },

        handleRemoveExtraCharmItem: function (event) {
            const item = event.currentTarget;
            const itemParent = item.closest("li");
            const { extraCharms: { count, charms } } = this.currentState;
            const itemIdentifier = item.classList.contains("badge-remove") ? "uniqueId" : "title";
            if (itemParent) itemParent.classList.remove("active");
            document.querySelector(`.extra-badge-collection__item[data-title='${item.dataset.alt}']`)?.closest("li")?.classList.remove("active")
            const updatedCharms = [...charms].filter((charm) => charm[itemIdentifier] !== item.dataset[itemIdentifier]);
            this.currentState.extraCharms.charms = updatedCharms;
            this.currentState.extraCharms.count = updatedCharms.length
            this.renderSelectedExtraCharms();
        },

        handleExtraCharmAddToCart: function () {
            this.closeExtraCharmPopup();
            // const additionalCharmVariantId = window.personalization.additional_charm_product.id;
            // const itemsArray = this.currentState.extraCharms.charms.map((charm) => ({ id: variantId, quantity: 1, properties: { title: charm.title } }));
            // const formData = { items: itemsArray };

            // fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) }).then(res => res.json())
            //     .then((response) => {
            //         window.location.href = `${window.Shopify.routes.root}cart`;
            //     }).catch((error) => {
            //         console.error('Error:', error);
            //     });
        },

        bindBadgeEvents: function () {
            var _ = this;
            const badgeItems = Array.from(this.personalizeBelt.querySelectorAll(this.selectors.badgeItem));
            if (badgeItems.length) {
                badgeItems.forEach((badgeItem) => {
                    if (!badgeItem.classList.contains("evt-binded")) {
                        badgeItem.classList.add("evt-binded")
                        const badgeActionDeleteBtn = badgeItem.querySelector(_.selectors.badgeActionDelete);
                        const badgeActionDrag = badgeItem.querySelector(".personalize-badge__wrapper");
                        badgeActionDeleteBtn.addEventListener("click", _.handleBadgeAction.bind(this), true);

                        badgeItem.addEventListener("drop", _.handleBadgeAction.bind(this), true);
                        badgeItem.addEventListener("dragover", _.handleBadgeAction.bind(this), true);
                        badgeActionDrag.addEventListener("dragstart", _.handleBadgeAction.bind(this), true);
                        badgeActionDrag.addEventListener("dragend", _.handleBadgeAction.bind(this), true);

                    }
                });
            }
        },

        handleBadgeAction: function (event) {
            const action = event.currentTarget.dataset.name;

            if (action === "delete") {
                // Proceed with deleting the badge
                event.currentTarget.closest(this.selectors.badgeItem).remove();
                this.bindBadgeEvents();
                this.manageBadgeCount("minus");
            } else {
                switch (event.type) {
                    case "dragstart": {
                        event.currentTarget.classList.add("dragging");
                        event.dataTransfer.clearData();
                        event.dataTransfer.setData("text/plain", event.currentTarget.id);
                        break;
                    }
                    case "dragend": {
                        event.currentTarget.classList.remove("dragging");
                        break;
                    }
                    case "drop": {
                        event.preventDefault();
                        var src = document.getElementById(event.dataTransfer.getData("text"));
                        var srcParent = src.parentNode;
                        var tgt = event.currentTarget.firstElementChild;
                        event.currentTarget.replaceChild(src, tgt);
                        srcParent.appendChild(tgt);
                        break;
                    }
                    case "dragover": {
                        event.preventDefault();
                        break;
                    }
                    case "click": {
                        break;
                    }

                    default: {
                        console.log("Hmmm. Something is not right!");
                        break;
                    }
                }
            }
        },

        handleColorChange: function (event) {
            const swatchColorCode = event.currentTarget.dataset.colorCode;
            const colorValue = event.currentTarget.dataset.value;
            this.personalizeBelt.style.backgroundColor = swatchColorCode;
            const colorInput = document.querySelector(`input[value='${colorValue}']`);
            if (colorInput) colorInput.click();
        },

        handleVariantChange: function (event) {
            const productJson = JSON.parse(document.querySelector(".product-json").innerText);
            const variant = event?.detail?.variant || productJson.current_variant;

            this.variant = variant;
            const variantOptions = variant.options;
            const colorSwatchMeta = productJson.metafields.color_swatch;
            const charmLimitMeta = productJson.metafields.charm_limit;

            //let collarLimit = this.currentState.maxBadgeCount;
            let collarLimit = 20;
            let collarColor = this.variant.option1;
            let collarSize = this.variant.option1;

            for (const option of variantOptions) {
                const foundCharmLimit = this.getMatchingMetaValue(option, charmLimitMeta);
                if (foundCharmLimit) {
                    collarLimit = charmLimitMeta[foundCharmLimit];
                    collarSize = option;
                    break;
                }
            }

            for (const option of variantOptions) {
                const foundCollarColor = this.getMatchingMetaValue(option, colorSwatchMeta);
                if (foundCollarColor) {
                    collarColor = option;
                    break;
                }
            }

            this.currentState.collarColor = collarColor;
            this.currentState.collarSize = collarSize;

            const personalizationSwatch = document.querySelector(`button[data-value='${collarColor}']`);
            if (personalizationSwatch) personalizationSwatch.click();

            if (parseInt(collarLimit) < this.currentState.maxBadgeCount) {
                this.resetStrip();
            }

            this.currentState.maxBadgeCount = parseInt(collarLimit);
            this.badgeMaxCount.innerText = collarLimit;

            this.showAvailableCollection();
        },

        showAvailableCollection: function () {
            let collarSize = this.variant.option1;
            if (!collarSize) {
                return;
            }
            collarSize = collarSize.toLowerCase();
            console.log("Collar Size", collarSize);
            this.badgeCollectionBtns.forEach((badgeCollectionBtn) => {
                const notAvailableOn = badgeCollectionBtn.dataset.available;
                if (notAvailableOn) {
                    const listOfUnavailableCollections = notAvailableOn.split(",").map((item) => item.toLowerCase());
                    if (listOfUnavailableCollections.indexOf(collarSize) > -1) {
                        badgeCollectionBtn.closest("li").classList.add("hidden");
                    } else {
                        badgeCollectionBtn.closest("li").classList.remove("hidden");
                    }
                }
            })
        },

        handleAddToCart: function (event) {
            var _ = this;
            const variant = this.variant;
            let charmsList = Array.from(this.wrapper.querySelectorAll(this.selectors.badgeInput)).map((charm) => charm.value);
            let quantity = document.querySelector(".product__section").querySelector("input[name='quantity']").value;
            const itemsArray = [];
            const data = { id: variant.id, quantity: quantity };
            const additionalCharmVariantId = window.personalization?.additional_charm_product?.id;
            const timestamp = new Date().getTime();
            if (additionalCharmVariantId != undefined && this.currentState.extraCharms.charms.length) {
                const additonalCharmsItems = this.currentState.extraCharms.charms.map((charm) => ({ id: additionalCharmVariantId, quantity: 1, properties: { "_is_additional": true, title: charm.title, "_id": timestamp } }));
                data.properties["Additional Charms"] = this.currentState.extraCharms.charms.map((charm) => charm.title).join(",");
                data.properties["_main"] = timestamp;
                itemsArray.push(...additonalCharmsItems);
            } else {
              const additionalCharmsList = Array.from(this.wrapper.querySelectorAll(this.selectors.badgeInput)).map((charm) => {
                console.log(charm);
                return { id: charm.dataset.variantId, quantity: 1 }
              });
              itemsArray.push(...additionalCharmsList);
            }
            itemsArray.push(data);
            // console.log("itemsArray", itemsArray);
            let formData = { 'items': itemsArray };
            fetch(window.Shopify.routes.root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(formData) }).then(res => res.json())
                .then((response) => {
                    window.location.href = `${window.Shopify.routes.root}cart`;
                }).catch((error) => {
                    console.error('Error:', error);
                });
        },

        manageBadgeCount: function (operation) {
            operation === "plus" ? this.currentState.currentBadgeCount = this.currentState.currentBadgeCount + 1 : this.currentState.currentBadgeCount = this.currentState.currentBadgeCount - 1;
            this.badgeCurrentCount.innerText = this.currentState.currentBadgeCount;
        },

        renderSelectedExtraCharms: function () {
            const _this = this;
            const { extraCharms: { count, charms } } = this.currentState;
            this.selectedExtraCharms.innerHTML = "";

            if (charms.length) {
                for (let charm of charms) {
                    let emptyCharmItem = this.getExtraCharmSelectedItem();
                    let stringsToReplaceWith = { "ItemSrc": charm.image, "ItemTitle": charm.title, "UniqueId": charm.uniqueId };
                    emptyCharmItem = emptyCharmItem.replace(/\b(?:ItemSrc|ItemTitle|UniqueId)\b/gi, matched => stringsToReplaceWith[matched]);
                    this.selectedExtraCharms.insertAdjacentHTML("beforeend", emptyCharmItem);
                }
                this.extraCharmsAddToCartBtn.removeAttribute("disabled");
                const totalPrice = charms.length * window.personalization.additional_charm_product.price;
                this.extraCharmsAddToCartBtn.querySelector(".total-price").innerText = theme.Helpers.formatMoney(totalPrice, window.personalization.money_format);
            } else {
                const emptyList = `<li class="badge-empty__list-item"><p>No Charms selected.</p></li>`;
                this.selectedExtraCharms.insertAdjacentHTML("beforeend", emptyList);
                this.extraCharmsCollectionItems.forEach((extraCharmsCollectionItem) => extraCharmsCollectionItem.closest("li").classList.remove("active"));
                this.extraCharmsAddToCartBtn.setAttribute("disabled", true);
                this.extraCharmsAddToCartBtn.querySelector(".total-price").innerText = theme.Helpers.formatMoney(0, window.personalization.money_format);
            }

            const extraCharmRemoveBtns = Array.from(this.extraCharmsWrapper.querySelectorAll(this.selectors.extraCharmRemoveBtns));
            if (extraCharmRemoveBtns.length) {
                extraCharmRemoveBtns.forEach((extraCharmRemoveBtn) => extraCharmRemoveBtn.addEventListener("click", _this.handleRemoveExtraCharmItem.bind(this), true));
            }
        },

        getUniqueId: function () {
            let result = '';
            const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            const charactersLength = characters.length;
            let counter = 0;
            while (counter < 4) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
                counter += 1;
            }
            return result;
        },

        getMatchingMetaValue: function (option, meta) {
            const optionHandle = option.toLowerCase();
            for (const key in meta) {
                if (key == optionHandle) {
                    return key;
                }
            }
            return null;
        },

        getExtraCharmSelectedItem: function () {
            return `<li> <img src="ItemSrc" alt="ItemTitle"> <button class="badge-remove extra-charm-remove" data-title="ItemTitle" data-unique-id="UniqueId"> <svg class="fash--apollo-close " height="14px" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 20 20" xml:space="preserve"> <g class="hover-fill" fill=""> <polygon points="20,2 18,0 10,8 2,0 0,2 8,10 0,18 2,20 10,12 18,20 20,18 12,10 "> </polygon> </g> </svg> </button> </li>`
        },

        resetStrip: function () {
            this.wrapper.querySelector(this.selectors.personalizeBelt).innerHTML = "";
            this.badgeCurrentCount.innerText = 0;
            this.currentState.currentBadgeCount = 0;
        },

        forEachWithBreak(array, callback) {
            for (let i = 0; i < array.length; i++) {
                if (callback(array[i], i, array) === false) {
                    return;
                    // this will break out of the loop
                }
            }
        },

        getBadgeHTML: function () {
            let html = `<div class="personalize_badge"> <div id="Index" class="personalize-badge__wrapper" data-name="drag" draggable="true"> <div class="personalize_badge_tooltip"> <ul> <li> <button type="button" data-name="drag" class="badge-action"> ${window.personalization.drag_icon} </button> </li> <li> <button type="button" data-name="delete" class="badge-action"> ${window.personalization.delete_icon} </button> </li> </ul> </div> <input data-variant-id="BadgeVariantId" type="hidden" class="personalize-badge__input" value="BadgeValue"/> <img class="badge-image" loading="eager" width="auto" height="auto" src="BadgeImage" alt="BadgeCollectionTitle"> </div> </div>`;
            return html;
        }
    };
    PersonalizeProduct.init();
})();